import { render, staticRenderFns } from "./supplier-import.vue?vue&type=template&id=f4d3deee&scoped=true&"
import script from "./supplier-import.vue?vue&type=script&lang=js&"
export * from "./supplier-import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d3deee",
  null
  
)

export default component.exports